'use client';

import type { Database } from '@root/database';
import type { User as SupabaseUser } from '@supabase/supabase-js';
import { LogOut, Shield, User, Users } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { signInWithGoogle, signOut } from '@/lib/auth/actions';
interface AuthButtonProps {
  user: SupabaseUser | null;
  userRole: Database['public']['Enums']['user_role_enum'] | null;
}
export const AuthButton = ({
  user,
  userRole
}: AuthButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleSignIn = async () => {
    setIsLoading(true);
    try {
      await signInWithGoogle();
    } finally {
      setIsLoading(false);
    }
  };
  const handleSignOut = async () => {
    setIsLoading(true);
    try {
      await signOut();
      window.location.reload();
    } finally {
      setIsLoading(false);
    }
  };
  if (!user) {
    return <Button disabled={isLoading} variant="secondary" onClick={handleSignIn}>
        {isLoading ? <Spinner /> : <User />}
        Se connecter avec Google
      </Button>;
  }
  const RoleIcon = userRole === 'admin' ? Shield : Users;
  const roleLabel = userRole === 'admin' ? 'Admin' : 'Membre';
  return <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm text-white">{user.email}</span>
        {userRole && <div className="flex items-center gap-1 rounded-full bg-white/20 px-2 py-1">
            <RoleIcon className="h-3 w-3 text-white" />
            <span className="text-xs font-medium text-white">{roleLabel}</span>
          </div>}
      </div>
      <Button aria-label="Se déconnecter" disabled={isLoading} size="icon" title="Se déconnecter" variant="secondary" onClick={handleSignOut}>
        {isLoading ? <Spinner /> : <LogOut />}
      </Button>
    </div>;
};